import { Form, Input, InputNumber, Select } from 'antd';
import { isArray } from 'radash';
import { FC } from 'react';
import { LEFT, NEGATIVE, POSITIVE, RIGHT } from '../const';
import RowPosition from '../row-position';
import { IRule } from '../type';
import PositiveNegativeInput from '../positive-negative-input';

const { Item: FormItem } = Form;
const { Item: StyleItem } = Form;

const RowItem: FC<{
  prefix: (string | number)[];
  fullPrefix: (string | number)[];
}> = ({ prefix, fullPrefix }) => {
  // const form = Form.useFormInstance();
  return (
    <>
      <RowPosition prefix={prefix} fullPrefix={fullPrefix} />

      {/* <FormItem
        className="mb-0"
        label="行定位"
        name={[...prefix, 'row_config', 'position_method']}
      >
        <Select
          onChange={() => {
            // TODO 行顺序、列顺序的默认值
            form.setFieldValue(
              [...fullPrefix, 'row_config', 'offset_config'],
              undefined,
            );
          }}
          options={[
            {
              label: `关键词所在行`,
              value: 'KEYWORD',
            },
            {
              label: `行顺序`,
              value: 'ORDER',
            },
          ]}
        />
      </FormItem> */}

      {/* 行定位 关键词所在行 展示 关键词或正则表达式/偏移 */}

      {/* 行定位 行顺序 展示 正倒数 */}
      {/* <FormItem noStyle shouldUpdate={() => true}>
        {({ getFieldValue }) => {
          const position_method = getFieldValue([
            ...fullPrefix,
            'row_config',
            'position_method',
          ]) as IRule['row_content_config']['row_config']['position_method'];

          // 行顺序
          if (position_method === 'ORDER') {
            return (
              <StyleItem label=" ">
                <section className="flex gap-4">
                  <FormItem
                    className="flex-1"
                    name={[
                      ...prefix,
                      'row_config',
                      'offset_config',
                      'direction',
                    ]}
                  >
                    <Select
                      options={[
                        {
                          label: '正数',
                          value: POSITIVE,
                        },
                        {
                          label: '倒数',
                          value: NEGATIVE,
                        },
                      ]}
                    />
                  </FormItem>
                  <FormItem
                    className="flex-2"
                    name={[...prefix, 'row_config', 'offset_config', 'offset']}
                  >
                    <InputNumber
                      suffix="行"
                      className="w-full"
                      max={99999}
                      min={-99999}
                    />
                  </FormItem>
                </section>
              </StyleItem>
            );

            // 关键词所在行
          } else if (position_method === 'KEYWORD') {
            return (
              <>
                <FormItem label=" " name={[...prefix, 'row_config', 'keyword']}>
                  <Input allowClear placeholder="请输入关键词或正则表达式" />
                </FormItem>
                <section className="flex gap-4">
                  <FormItem
                    className="flex-1"
                    name={[
                      ...prefix,
                      'row_config',
                      'offset_config',
                      'direction',
                    ]}
                  >
                    <Select
                      options={[
                        {
                          label: '向上偏移',
                          value: UP,
                        },
                        {
                          label: '向下偏移',
                          value: DOWN,
                        },
                      ]}
                    />
                  </FormItem>
                  <FormItem
                    className="flex-2"
                    name={[...prefix, 'row_config', 'offset_config', 'offset']}
                  >
                    <InputNumber className="w-full" max={99999} min={-99999} />
                  </FormItem>
                </section>
              </>
            );
          }
        }}
      </FormItem> */}
      <FormItem label="列范围" shouldUpdate={() => true}>
        <FormItem name={[...prefix, 'colum_range_config', 'range_type']}>
          <Select
            options={[
              {
                label: '全部列',
                value: 'ALL',
              },
              {
                label: '自定义',
                value: 'CUSTOM',
              },
            ]}
          />
        </FormItem>
        {/* 当选择 自定义 时，展示 开始列、结束列 */}
        <FormItem noStyle shouldUpdate={() => true}>
          {({ getFieldValue }) => {
            const range_type = getFieldValue([
              ...fullPrefix,
              'colum_range_config',
              'range_type',
            ]) as IRule['row_content_config']['colum_range_config']['range_type'];
            if (range_type === 'ALL') return null;

            return (
              <>
                <ColBeginItem
                  prefix={[...prefix, 'colum_range_config', 'begin']}
                  fullPrefix={[...fullPrefix, 'colum_range_config', 'begin']}
                />
                <ColEndItem
                  prefix={[...prefix, 'colum_range_config', 'end']}
                  fullPrefix={[...fullPrefix, 'colum_range_config', 'end']}
                />
              </>
            );
          }}
        </FormItem>
      </FormItem>
    </>
  );
};

/**
 * 列起始和列结束 结构一样
 * ColBeginItem  ColEndItem
 */
const ColBeginItem: FC<{
  prefix: (string | number)[];
  fullPrefix: (string | number)[];
}> = ({ prefix, fullPrefix }) => {
  const form = Form.useFormInstance();
  return (
    <>
      {/* 列起始 和 列结束结构一样 */}
      {/* 列起始 */}
      <>
        <FormItem label="列起始" name={[...prefix, 'position_method']}>
          <Select
            onChange={(e, option) => {
              if (isArray(option)) {
                form.setFieldValue([...fullPrefix, 'offset_config'], undefined);
                return;
              }

              // TODO 行顺序、列顺序的默认值
              const value =
                option.value as IRule['row_content_config']['colum_range_config']['begin']['position_method'];

              if (value === 'ORDER') {
                form.setFieldValue([...fullPrefix, 'offset_config'], {
                  direction: 'POSITIVE',
                  offset: 1,
                });
              } else if (value === 'KEYWORD') {
                form.setFieldValue([...fullPrefix, 'offset_config'], {
                  direction: 'LEFT',
                  offset: 0,
                });
              }
            }}
            options={[
              {
                label: `关键词所在列`,
                value: 'KEYWORD',
              },
              {
                label: `列顺序`,
                value: 'ORDER',
              },
            ]}
          />
        </FormItem>

        {/* 行定位 行顺序 展示 正倒数 */}
        <FormItem noStyle shouldUpdate={() => true}>
          {({ getFieldValue }) => {
            const position_method = getFieldValue([
              ...fullPrefix,
              'position_method',
            ]) as IRule['row_content_config']['colum_range_config']['begin']['position_method'];
            // 行顺序
            if (position_method === 'ORDER') {
              return (
                <>
                  <FormItem name={[...prefix, 'offset_config']}>
                    <PositiveNegativeInput
                      inputNumberProps={{ suffix: '列' }}
                    />
                  </FormItem>
                  {/* <StyleItem>
                    <section className="flex gap-4">
                      <FormItem
                        className="flex-1"
                        name={[...prefix, 'offset_config', 'direction']}
                      >
                        <Select
                          options={[
                            {
                              label: '正数',
                              value: POSITIVE,
                            },
                            {
                              label: '倒数',
                              value: NEGATIVE,
                            },
                          ]}
                        />
                      </FormItem>
                      <FormItem
                        className="flex-2"
                        name={[...prefix, 'offset_config', 'offset']}
                        rules={[
                          {
                            required: true,
                            message: '',
                            warningOnly: true,
                            type: 'number',
                          },
                        ]}
                      >
                        <InputNumber
                          suffix="列"
                          className="w-full"
                          max={99999}
                          min={-99999}
                        />
                      </FormItem>
                    </section>
                  </StyleItem> */}
                </>
              );

              // 关键词所在行
            } else if (position_method === 'KEYWORD') {
              return (
                <>
                  <FormItem
                    name={[...prefix, 'keyword']}
                    rules={[{ required: true, message: '', warningOnly: true }]}
                  >
                    <Input allowClear placeholder="请输入关键词或正则表达式" />
                  </FormItem>
                  <section className="flex gap-4">
                    <FormItem
                      className="flex-1"
                      name={[...prefix, 'offset_config', 'direction']}
                    >
                      <Select
                        options={[
                          {
                            label: '向左偏移',
                            value: LEFT,
                          },
                          {
                            label: '向右偏移',
                            value: RIGHT,
                          },
                        ]}
                      />
                    </FormItem>
                    <FormItem
                      className="flex-2"
                      name={[...prefix, 'offset_config', 'offset']}
                      rules={[
                        {
                          required: true,
                          message: '',
                          warningOnly: true,
                          type: 'number',
                        },
                      ]}
                    >
                      <InputNumber
                        suffix="列"
                        className="w-full"
                        min={0}
                        max={99999}
                      />
                    </FormItem>
                  </section>
                </>
              );
            }
          }}
        </FormItem>
      </>
    </>
  );
};

/**
 * 列起始和列结束 结构一样
 * ColBeginItem  ColEndItem
 */
const ColEndItem: FC<{
  prefix: (string | number)[];
  fullPrefix: (string | number)[];
}> = ({ prefix, fullPrefix }) => {
  const form = Form.useFormInstance();
  return (
    <>
      {/* 列结束 */}
      <FormItem label="列结束" name={[...prefix, 'position_method']}>
        <Select
          onChange={(e, option) => {
            if (isArray(option)) {
              form.setFieldValue([...fullPrefix, 'offset_config'], undefined);
              return;
            }

            const value =
              option.value as IRule['row_content_config']['colum_range_config']['begin']['keyword'];
            if (value === 'ORDER') {
              form.setFieldValue([...fullPrefix, 'offset_config'], {
                direction: NEGATIVE,
                offset: 1,
              });
            } else if (value === 'KEYWORD') {
              form.setFieldValue([...fullPrefix, 'offset_config'], {
                direction: 'LEFT',
                offset: 0,
              });
            }
          }}
          options={[
            {
              label: `关键词所在列`,
              value: 'KEYWORD',
            },
            {
              label: `列顺序`,
              value: 'ORDER',
            },
          ]}
        />
      </FormItem>

      {/* 行定位 行顺序 展示 正倒数 */}
      <FormItem noStyle shouldUpdate={() => true}>
        {({ getFieldValue }) => {
          const position_method = getFieldValue([
            ...fullPrefix,
            'position_method',
          ]) as IRule['row_content_config']['colum_range_config']['end']['position_method'];
          // 行顺序
          if (position_method === 'ORDER') {
            return (
              <FormItem name={[...prefix, 'offset_config']}>
                <PositiveNegativeInput inputNumberProps={{ suffix: '列' }} />
              </FormItem>
            );

            // 关键词所在行
          } else if (position_method === 'KEYWORD') {
            return (
              <>
                <FormItem
                  name={[...prefix, 'keyword']}
                  rules={[{ required: true, message: '', warningOnly: true }]}
                >
                  <Input allowClear placeholder="请输入关键词或正则表达式" />
                </FormItem>
                <section className="flex gap-4">
                  <FormItem
                    className="flex-1"
                    name={[...prefix, 'offset_config', 'direction']}
                  >
                    <Select
                      options={[
                        {
                          label: '向左偏移',
                          value: LEFT,
                        },
                        {
                          label: '向右偏移',
                          value: RIGHT,
                        },
                      ]}
                    />
                  </FormItem>
                  <FormItem
                    className="flex-2"
                    name={[...prefix, 'offset_config', 'offset']}
                    rules={[
                      {
                        required: true,
                        message: '',
                        warningOnly: true,
                        type: 'number',
                      },
                    ]}
                  >
                    <InputNumber
                      className="w-full"
                      min={0}
                      max={99999}
                      suffix="列"
                    />
                  </FormItem>
                </section>
              </>
            );
          }
        }}
      </FormItem>
    </>
  );
};

export default RowItem;
